import React, { useEffect, useState, useRef, useContext } from "react";
import Info from "../Info/info";
import InfoTitle from "../Info/InfoTitle";
import styles from "../Add Beneficiary/styles/new_beneficiary.module.css";
import PhoneInput from "react-phone-input-2";
import fr_phone_countries from "react-phone-input-2/lang/fr.json";
import "./styles/phone.css";
import { Switch } from "@mui/material";
import { Beneficiarytrustee } from "../Beneficiarytrustee/Beneficiarytrustee";
import PartnerSharingPerson, {
  EMPTY_PERSON_SHARING,
  personSharingValue,
} from "../Partner Sharing/PartnerSharingPerson";
import { getPartner } from "../Partner Sharing/PartnerSharing";
import { encryptTrustee } from "../../../Utils/dataEncryption";
import AssetType from "../Asset Type/AssetType";
import { UserData } from "../../../Context/DataContext";
import AddNewAsset from "./AddNewAsset";
import AddBeneficiary from "../Add Asset/AddBeneficiary";
import { GenerateID, RandomId } from "../../../Utils/RandomId";
import config from "../../../config";
import { handleIssues } from "../../../Utils/handleIssues";
import { sendEmail } from "../../../Utils/beneficiary";
import { floatMessage } from "../../../Utils/floatMessage";
import { useAuth } from "../../../Context/AuthContext";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import uploadButton from "../Add Beneficiary/styles/img/upload_button.png";
import editButton from "../Add Beneficiary/styles/img/edit_button.svg";
import { Upload as UploadProfilePicture } from "antd";
import CropperImage from "antd-cropper-img";
import { DeleteOutlined } from "@ant-design/icons";
import { encodeFileToBase64 } from "../../../Utils/encodeFile";
import useWindowDimensions from "../../Footer/footer";
import { encryptFileAES } from "../../../Utils/OstreonEncryption";
const base_url = config.base_url;
function NewTrustee({ onClose }) {
  const [previewImage, setPreviewImage] = useState(null);
  const [image, setImage] = useState(null);
  const { height, width } = useWindowDimensions();

  const [showTopShadow, setShowTopShadow] = useState(false);
  const [showBottomShadow, setShowBottomShadow] = useState(false);
  const websiteCurrentLang = useContext(LanguageContext).language;

  const [content, setContent] = useState(
    websiteCurrentLang.content.User.AddTrustee.NewTrustee
  );
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    setContent(websiteCurrentLang.content.User.AddTrustee.NewTrustee);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  const divElementRef = useRef(null);

  useEffect(() => {
    const divElement = divElementRef.current;

    const handleScroll = () => {
      const scrollTop = divElement.scrollTop;
      const scrollHeight = divElement.scrollHeight;
      const clientHeight = divElement.clientHeight;
      setShowTopShadow(scrollTop > 0);
      setShowBottomShadow(scrollTop + clientHeight < scrollHeight - 10);
    };

    // Call handleScroll once on initial load to set shadows
    handleScroll();

    divElement.addEventListener("scroll", handleScroll);

    return () => {
      divElement.removeEventListener("scroll", handleScroll);
    };
  }, [height]);

  const userData = UserData();
  const auth = useAuth();
  const index_ = userData?.UserData?.trustees.map((trustee) => {
    return trustee.user_id;
  });
  const customer_id = userData?.UserData?.user_id;
  const [trustee, setTrustee] = useState({
    user_id: GenerateID(customer_id, "T", index_),
    name: "",
    additional_information: "",
    email: "",
    phone_number: "",
    awareness_status: false,
    assets: [],
    beneficiaries: [],
    /*
      Partner sharing, off for both. Stored unencrypted on the advisor, like the
      pair on a beneficiary, so the server can filter on them.
    */
    ...EMPTY_PERSON_SHARING,
  });
  /*
    Null when this user has no partner, which is what hides the section.
  */
  const partner = getPartner(userData);

  const [error, setError] = useState({
    name: "",
    email: "",
    phone_number: "",
    additional_information: "",
  });

  const [duplicatedName, setDuplicatedName] = useState(false);
  const duplicateError = content.newTrusteeError1;
  // textarea
  const maxMessageLength = 10000; // Define the maximum character length for the message field

  const textareaRef = useRef(null);

  const handleChangeDescription = () => {
    const textarea = textareaRef.current;
    // Reset the textarea height to 0 to correctly calculate the scrollHeight
    textarea.style.height = "0";
    const height = textarea.scrollHeight;
    textarea.style.height = `${height}px`;
  };
  // textarea
  const isValidEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };
  const cleanErrors = () => {
    setTimeout(() => {
      setError({
        name: "",
        email: "",
        phone_number: "",
        additional_information: "",
      });
    }, 5000);
  };
  const isTrusteeEmpty = () => {
    let isEmpty = false;
    let error_ = {
      name: "",
      email: "",
      phone_number: "",
      additional_information: "",
    };
    if (trustee.additional_information.length > maxMessageLength) {
      isEmpty = true;
      error_ = { ...error_, additional_information: content.newTrusteeError2 };
    }
    if (trustee.name === "") {
      isEmpty = true;
      error_ = { ...error_, name: content.newTrusteeError3 };
    }

    // check if trusted advisor with this name is exist
    if (userData.UserData.trustees.length && trustee.name !== "") {
      const newTrusteeName = trustee.name;
      let hasMatchingAsset = userData.UserData.trustees.some(
        (trustItem) =>
          trustItem.name.toLowerCase() === newTrusteeName.toLowerCase()
      );

      if (hasMatchingAsset) {
        isEmpty = true;
        setDuplicatedName(true);
        document.getElementById("scrollContainer").scrollTop = 0;
      }
    }

    if (trustee.email === "" && trustee.phone_number === "") {
      isEmpty = true;
      error_ = { ...error_, contacts: content.newTrusteeError4 };
    }

    if (trustee.phone_number !== "" && trustee.phone_number.length < 3) {
      isEmpty = true;
      error_ = { ...error_, phone_number: content.newTrusteeError5 };
    }

    if (trustee.email !== "" && !isValidEmail(trustee.email)) {
      isEmpty = true;
      error_ = { ...error_, email: dublicatedcontent.dublicatedText47 };
    }

    setError(error_);
    cleanErrors();

    return isEmpty;
  };

  const handleSave = async (e) => {
    e.preventDefault();
    if (isTrusteeEmpty()) return;

    /*
      A partner adding a trusted advisor to their customer's account.

      An early return, as on the other two Add modals, and for the same reason:
      nothing below may run. The advisor is attached to no asset and no
      beneficiary -- doing that would mean writing to records the customer owns,
      which a partner may never do -- and none of it counts until the customer
      approves.

      Encrypted under the CUSTOMER's key:  is theirs in this view.
    */
    if (userData.partnerCreate) {
      const encrypted = await encryptTrustee(
        { ...trustee, assets: [], beneficiaries: [], profile_avatar: null },
        userData.private_key
      );
      // No progress modal on this one -- it never showed one.
      const result = await userData.partnerCreate("trustee", encrypted);
      if (result?.ok) {
        floatMessage(dublicatedcontent?.saved);
        onClose();
      } else {
        floatMessage(
          result?.detail ||
            dublicatedcontent?.an_error_occured_try_later ||
            "Something went wrong"
        );
      }
      return;
    }

    var new_assets = userData.UserData.assets.map((asset) => {
      if (trustee.assets.includes(asset.asset_id)) {
        return {
          ...asset,
          trustees: [...new Set([...asset.trustees, trustee.user_id])],
        };
      } else {
        return asset;
      }
    });
    var new_beneficiaries = userData.UserData.beneficiaries.map(
      (beneficiary) => {
        if (trustee.beneficiaries.includes(beneficiary.user_id)) {
          return {
            ...beneficiary,
            trustees: [...new Set([...beneficiary.trustees, trustee.user_id])],
          };
        } else {
          return beneficiary;
        }
      }
    );
    var new_issues = handleIssues({
      ...userData.UserData,
      trustees: [
        ...userData.UserData.trustees,
        {
          user_id: trustee.user_id,
          name: trustee.name,
          additional_information: trustee.additional_information,
          email: trustee.email,
          phone_number: trustee.phone_number,
          awareness_status: trustee.awareness_status,
        },
      ],
      assets: new_assets,
      beneficiaries: new_beneficiaries,
    });
    const trusteeAvatar = await encodeFileToBase64(image);

    userData.setUserData({
      ...userData.UserData,
      trustees: [
        ...userData.UserData.trustees,
        {
          user_id: trustee.user_id,
          name: trustee.name,
          additional_information: trustee.additional_information,
          email: trustee.email,
          phone_number: trustee.phone_number,
          awareness_status: trustee.awareness_status,
          profile_avatar: trusteeAvatar?.base64String,
          new: image ? true : false,
          /*
            Every sharing flag, from one place -- this rebuilds the advisor
            field by field and what it writes is what gets saved. Named by
            hand, rows added later were simply missed, and a customer who
            set them while adding an advisor found them off again the
            moment it saved. personSharingValue reads the key set from
            EMPTY_PERSON_SHARING, so the next row needs no edit here.
          */
          ...personSharingValue(trustee),
        },
      ],
      assets: new_assets,
      beneficiaries: new_beneficiaries,
      issues: new_issues,
    });
    if (trustee.awareness_status === "true") {
      sendEmail(trustee, "trustee", [trustee?.email]);
      auth.setAwarenessEmail(auth.awareness_email + 1);
    }
    userData.Update(RandomId(10));
    if (image) {
      console.log("debería de subir la foto");
      const formData = new FormData();
      formData.append("profile_id", trustee.user_id);
      const encrypted_image = await encryptFileAES(userData.private_key, image);
      formData.append("file", encrypted_image);
      fetch(base_url + "user/profile/pic/upload", {
        method: "POST",
        mode: "cors",
        body: formData,
        credentials: "include",
      }).finally(() => {
        return;
      });
    }
    onClose();
    floatMessage(dublicatedcontent?.saved);
    return;
  };
  const editTrustee = (key, value) => {
    setTrustee({ ...trustee, [key]: value });
  };
  const trimNameField = (value) => {
    const name = value.trim();
    editTrustee("name", name);
  };
  useEffect(() => {
    console.log(trustee);
  }, [trustee]);
  useEffect(() => {
    if (userData.isFreezed) return;
    document.documentElement.style.overflow = "hidden";
    return () => {
      document.documentElement.style.overflow = "unset";
    };
  }, []);

  const clearNameError = () => {
    setDuplicatedName(false);
  };

  return (
    <>
      {!userData.isFreezed && (
        <div className={styles.background}>
          <div
            onClick={(e) => {
              e.stopPropagation();
            }}
            style={
              width <= 599
                ? {
                    height: window.innerHeight - 10,
                  }
                : {}
            }
            className={styles.main_box}
          >
            <div onClick={onClose} className={styles.close_logo}></div>
            <div className={styles.title}>
              {dublicatedcontent.dublicatedText73}
            </div>
            <div
              className={styles.popup_scrollable}
              id="scrollContainer"
              ref={divElementRef}
            >
              <div
                className={`${styles.shadow_top} ${
                  showTopShadow ? styles.active : ""
                }`}
              />

              <div className={styles.main_data}>
                <div
                  className={styles.main_data_upper}
                  style={{
                    alignItems: "center",
                  }}
                >
                  <div className={styles.upper_left}>
                    <div
                      className={`${styles.input_title} ${styles.required_field}`}
                    >
                      {content.newTrusteeText1}
                    </div>
                    <input
                      onClick={(e) => clearNameError()}
                      onBlur={(e) => trimNameField(e.target.value)}
                      value={trustee.name}
                      onChange={(e) => editTrustee("name", e.target.value)}
                      className={`${styles.beneficiary_input} ${
                        error.name ? styles.field_error : ""
                      } ${duplicatedName ? styles.field_error : ""}`}
                      placeholder={content.newTrusteeText1}
                    ></input>
                    {duplicatedName ? (
                      <div className={styles.error_message}>
                        {duplicateError}
                      </div>
                    ) : null}
                    {error.name ? (
                      <div className={styles.error_message}>{error.name}</div>
                    ) : null}
                  </div>
                  {width > 590 && (
                    <div
                      className={styles.upper_right}
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        transform: "translateY(33px)",
                      }}
                    >
                      <div
                        className={`${styles.uploadPictureContainer} ${styles.black_logo_image}`}
                        style={{
                          width: "175px",
                          height: "175px",
                        }}
                      >
                        <div className={styles.upload_button_container}>
                          <div className={styles.upload_button}>
                            <div
                              data-close="false"
                              className={styles.upload_button}
                              style={{
                                left: "-45px",
                                top: "15px",
                              }}
                            >
                              {!previewImage && (
                                <img
                                  src={uploadButton}
                                  alt="upload button"
                                  style={{
                                    width: "110px",
                                    height: "110px",
                                  }}
                                />
                              )}

                              <CropperImage
                                dragMode="move"
                                rotatable={true}
                                zoomSlider={false}
                                zoomOnTouch={false}
                                wheelZoomRatio={0.2}
                                zoomOnWheel={true}
                                modalTitle={dublicatedcontent?.edit_image}
                                quality={0.4}
                                classNames={"xxx"}
                                scalable={true}
                                cropShape="round"
                                restore={true}
                              >
                                <UploadProfilePicture
                                  multiple={false}
                                  maxCount={1}
                                  accept=".jpg, .jpeg, .png"
                                  beforeUpload={(file) => {
                                    const reader = new FileReader();
                                    reader.readAsDataURL(file);
                                    setImage(file);
                                    reader.onload = (e) => {
                                      setPreviewImage(reader.result);
                                    };

                                    // Prevent upload
                                    return false;
                                  }}
                                  itemRender={(
                                    originNode,
                                    file,
                                    fileList,
                                    { remove }
                                  ) => {
                                    return (
                                      <div
                                        className={styles.previewImageContainer}
                                        style={{
                                          left: "4px",
                                          top: "0px",
                                          width: "102px",
                                          height: "102px",
                                        }}
                                      >
                                        {previewImage && (
                                          <>
                                            <img
                                              src={previewImage}
                                              alt="benef. "
                                              className={styles.previewImage}
                                            />

                                            <div
                                              className={
                                                styles.displayDeleteIcon
                                              }
                                            >
                                              <div
                                                className={styles.deletBackdrop}
                                              />
                                              <div
                                                className={styles.deleteIcon}
                                                onClick={(e) => {
                                                  remove(file);
                                                  setImage(null);
                                                  setPreviewImage(null);
                                                }}
                                              >
                                                <DeleteOutlined />
                                              </div>
                                            </div>
                                          </>
                                        )}
                                      </div>
                                    );
                                  }}
                                >
                                  <div
                                    className={styles.upload_trigger}
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      justifyContent: "center",
                                      width: "110px",
                                      height: "110px",
                                      left: "5px",
                                    }}
                                  >
                                    {!previewImage && (
                                      <p
                                        className={styles.uploadText}
                                        style={
                                          localStorage.getItem("language") ===
                                          "fr"
                                            ? {
                                                fontSize: "14px",
                                                marginRight: "5px",
                                                width: "100px",
                                              }
                                            : {
                                                fontSize: "12px",
                                                marginLeft: "5px",
                                                paddingRight: "10px",
                                              }
                                        }
                                      >
                                        {content.newTrusteeText24}
                                      </p>
                                    )}

                                    {previewImage && (
                                      <img
                                        className={styles.editButton}
                                        style={{
                                          bottom: "10px",
                                          right: "12px",
                                          zIndex: "5",
                                        }}
                                        src={editButton}
                                        alt="edit"
                                      />
                                    )}
                                  </div>
                                </UploadProfilePicture>
                              </CropperImage>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
              <div className={styles.delay_period}>
                <div
                  className={`${styles.bold_title} ${styles.required_field}`}
                >
                  {content.newTrusteeText2}
                </div>
                <Info message={content.newTrusteeText3} />
              </div>
              <div className={styles.error_message}>
                {error.contacts ? error.contacts : null}
              </div>
              <div
                className={`${styles.main_data_upper} ${
                  error.contacts ? styles.err_container : ""
                }`}
              >
                <div className={styles.upper_left}>
                  <div className={`${styles.input_title}`}>
                    {content.newTrusteeText4}
                  </div>
                  <input
                    style={{ border: error.email ? "0.5px solid red" : null }}
                    value={trustee.email}
                    onChange={(e) => editTrustee("email", e.target.value)}
                    className={styles.beneficiary_input_email}
                    placeholder={content.newTrusteeText4}
                  ></input>
                  <div className={styles.error_message}>
                    {error.email ? error.email : null}
                  </div>
                  <div className={styles.choice}>
                    <InfoTitle
                      message={content.newTrusteeText5}
                      title={content.newTrusteeText6}
                      type={"small"}
                    />
                    <div
                      disabled={
                        userData.isFreezed || auth.awareness_email >= 12
                      }
                      className={`${styles.choice_container} ${
                        isValidEmail(trustee.email)
                          ? ""
                          : styles.disabled_choice
                      }`}
                    >
                      <span className={styles.switch_option}>
                        {dublicatedcontent?.dublicatedText102}
                      </span>
                      <div className={styles.switch_toggle}>
                        <Switch
                          checked={trustee.awareness_status === "true"}
                          onClick={() =>
                            editTrustee(
                              "awareness_status",
                              trustee.awareness_status === "true"
                                ? "false"
                                : "true"
                            )
                          }
                        />
                      </div>
                      <span
                        className={styles.switch_option}
                        style={{ marginRight: "10px" }}
                      >
                        {dublicatedcontent?.dublicatedText101}
                      </span>
                    </div>
                  </div>
                  {auth.awareness_email >= 12 && (
                    <div className={styles.error_message}>
                      {content.newTrusteeText7}
                    </div>
                  )}
                </div>
                <div className={styles.upper_right}>
                  <div className={styles.input_title}>
                    {content.newTrusteeText8}
                  </div>
                  <div
                    className={styles.phone_div}
                    style={{
                      border: error.phone_number ? "0.5px solid red" : null,
                    }}
                  >
                    <PhoneInput
                      localization={
                        websiteCurrentLang?.label === "fr"
                          ? fr_phone_countries
                          : undefined
                      }
                      country={websiteCurrentLang?.label === "fr" ? "fr" : "us"}
                      placeholder={content.newTrusteeText9}
                      onChange={(e) => editTrustee("phone_number", e)}
                    />
                  </div>
                  <div className={styles.error_message}>
                    {error.phone_number ? error.phone_number : null}
                  </div>
                  <InfoTitle
                    movetoleft={true}
                    message={content.newTrusteeText10}
                    title={content.newTrusteeText11}
                    type={"small"}
                  />
                </div>
              </div>
              {width <= 590 && (
                <div
                  className={styles.upper_right}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <div
                    className={`${styles.uploadPictureContainer} ${styles.black_logo_image}`}
                    style={{
                      width: "200px",
                      height: "200px",
                    }}
                  >
                    <div className={styles.upload_button_container}>
                      <div className={styles.upload_button}>
                        <div className={styles.upload_button}>
                          {!previewImage && (
                            <img
                              src={uploadButton}
                              alt="upload button"
                              style={{
                                width: "120px",
                                height: "120px",
                              }}
                            />
                          )}

                          <CropperImage
                            dragMode="move"
                            rotatable={true}
                            zoomSlider={false}
                            zoomOnTouch={false}
                            wheelZoomRatio={0.2}
                            zoomOnWheel={true}
                            modalTitle={dublicatedcontent?.edit_image}
                            quality={0.4}
                            classNames={"xxx"}
                            scalable={true}
                            cropShape="round"
                            restore={true}
                          >
                            <UploadProfilePicture
                              multiple={false}
                              maxCount={1}
                              accept=".jpg, .jpeg, .png"
                              beforeUpload={(file) => {
                                const reader = new FileReader();
                                reader.readAsDataURL(file);
                                setImage(file);
                                reader.onload = (e) => {
                                  setPreviewImage(reader.result);
                                };

                                // Prevent upload
                                return false;
                              }}
                              itemRender={(
                                originNode,
                                file,
                                fileList,
                                { remove }
                              ) => {
                                return (
                                  <div
                                    className={styles.previewImageContainer}
                                    style={{
                                      left: "7px",
                                      top: "4px",
                                      width: "110px",
                                      height: "110px",
                                    }}
                                  >
                                    {previewImage && (
                                      <>
                                        <img
                                          src={previewImage}
                                          alt="benef. "
                                          className={styles.previewImage}
                                        />

                                        <div
                                          className={styles.displayDeleteIcon}
                                        >
                                          <div
                                            className={styles.deletBackdrop}
                                          />
                                          <div
                                            className={styles.deleteIcon}
                                            onClick={(e) => {
                                              remove(file);
                                              setImage(null);
                                              setPreviewImage(null);
                                            }}
                                          >
                                            <DeleteOutlined />
                                          </div>
                                        </div>
                                      </>
                                    )}
                                  </div>
                                );
                              }}
                            >
                              <div
                                className={styles.upload_trigger}
                                style={{
                                  width: "120px",
                                  height: "120px",
                                  display: "flex",
                                  alignItems: "center",
                                  justifyContent: "center",
                                }}
                              >
                                {!previewImage && (
                                  <p
                                    className={styles.uploadText}
                                    style={
                                      localStorage.getItem("language") === "fr"
                                        ? {
                                            fontSize: "13px",
                                            marginLeft: "5px",
                                            width: "100px",
                                          }
                                        : {
                                            fontSize: "13px",
                                            marginLeft: "5px",
                                          }
                                    }
                                  >
                                    {content.newTrusteeText24}
                                  </p>
                                )}

                                {previewImage && (
                                  <img
                                    className={styles.editButton}
                                    src={editButton}
                                    alt="edit"
                                    style={{
                                      zIndex: "5",
                                      right: "10px",
                                    }}
                                  />
                                )}
                              </div>
                            </UploadProfilePicture>
                          </CropperImage>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              )}
              <div className={styles.main_data_lower}>
                <div className={styles.delay_period}>
                  <div className={styles.input_title}>
                    {content.newTrusteeText12}
                  </div>
                </div>
                <textarea
                  maxlength={maxMessageLength}
                  value={trustee.additional_information}
                  ref={textareaRef}
                  placeholder={content.newTrusteeText12}
                  onChange={(e) => {
                    editTrustee("additional_information", e.target.value);
                    handleChangeDescription(e);
                  }}
                  className={styles.large_message}
                ></textarea>
                <div className={styles.error_message}>
                  {error.additional_information
                    ? error.additional_information
                    : null}
                </div>
                <div
                  className={`${styles.file_counter} ${
                    trustee.additional_information.length === maxMessageLength
                      ? styles.error_text
                      : ""
                  }`}
                >
                  {trustee.additional_information.length ===
                  maxMessageLength ? (
                    <>{content.newTrusteeText13} </>
                  ) : (
                    ""
                  )}
                  {trustee.additional_information.length}/{maxMessageLength}{" "}
                  {dublicatedcontent?.dublicatedText93}
                </div>
              </div>
              <div>
                <div className={styles.delay_period}>
                  <div className={styles.bold_title}>
                    {content.newTrusteeText14}
                  </div>
                  <Info message={content.newTrusteeText15} />
                  <div
                    onClick={() =>
                      setTrustee({
                        ...trustee,
                        assets: userData.UserData.assets.map((e) => {
                          return e.asset_id;
                        }),
                      })
                    }
                    className={styles.blue_link}
                  >
                    {content.newTrusteeText16}
                  </div>

                  <div className={styles.assets_counter}>
                    <span className={styles.assets_selected}>
                      {trustee?.assets.length}
                    </span>
                    /{userData.UserData.assets.length}{" "}
                    {content.newTrusteeText17}
                  </div>
                </div>
                <div className={styles.assets_div}>
                  <div className={styles.assets_container}>
                    {width > 590 && (
                      <AddNewAsset
                        alreadySelected={trustee.assets}
                        assets={userData.UserData.assets}
                        onClick={(asset) =>
                          editTrustee("assets", [
                            ...new Set([...trustee.assets, asset.asset_id]),
                          ])
                        }
                      />
                    )}
                    {trustee.assets.map((asset_id) => {
                      let asset_types;
                      userData.UserData.assets.map((asset) => {
                        if (asset.asset_id === asset_id)
                          asset_types = (
                            <AssetType
                              key={asset.asset_id}
                              asset_type={asset.asset_type}
                              asset_name={asset.asset_name}
                              onDelete={() =>
                                editTrustee(
                                  "assets",
                                  trustee.assets.filter(
                                    (e) => e !== asset.asset_id
                                  )
                                )
                              }
                            />
                          );
                        return null;
                      });
                      return asset_types;
                    })}
                    {width <= 590 && (
                      <AddNewAsset
                        alreadySelected={trustee.assets}
                        assets={userData.UserData.assets}
                        onClick={(asset) =>
                          editTrustee("assets", [
                            ...new Set([...trustee.assets, asset.asset_id]),
                          ])
                        }
                      />
                    )}
                  </div>
                </div>
                <div className={styles.delay_period}>
                  <div className={styles.bold_title}>
                    {content.newTrusteeText18}
                  </div>
                  <Info position={"top"} message={content.newTrusteeText19} />
                </div>
                <div className={styles.file_container}>
                  {trustee.beneficiaries.map((user_id) => {
                    let beneficiary_logo;
                    userData.UserData.beneficiaries.map((beneficiary) => {
                      if (beneficiary.user_id === user_id)
                        beneficiary_logo = (
                          <Beneficiarytrustee
                            name={beneficiary.name}
                            priority={beneficiary.priority}
                            deleatable={true}
                            onDelete={() =>
                              editTrustee(
                                "beneficiaries",
                                trustee.beneficiaries.filter(
                                  (e) => e !== beneficiary.user_id
                                )
                              )
                            }
                          />
                        );
                      return null;
                    });
                    return beneficiary_logo;
                  })}
                  {trustee?.beneficiaries.length <= 11 && (
                    <AddBeneficiary
                      setShow={() => null}
                      specialStyle={true}
                      alreadySelected={trustee.beneficiaries}
                      user_type={"beneficiaries"}
                      onSelect={(e) =>
                        editTrustee("beneficiaries", [
                          ...new Set([...trustee.beneficiaries, e.user_id]),
                        ])
                      }
                    />
                  )}
                  {/* <AddBeneficiary setShow={(e)=>setShow(e)} alreadySelected={asset.beneficiaries} user_type={"beneficiaries"} onSelect={(beneficiary)=>{
                                    setAsset({...asset, beneficiaries:[...asset.beneficiaries, beneficiary.user_id]})
                                }}/> */}
                </div>
              </div>

              {partner && (
                <PartnerSharingPerson
                  subject="trustee"
                  value={personSharingValue(trustee)}
                  onChange={(next) =>
                    setTrustee((current) => ({ ...current, ...next }))
                  }
                  disabled={userData.isFreezed}
                  partnerName={partner.name}
                />
              )}
              <div
                className={`${styles.shadow_bottom} ${
                  showBottomShadow ? styles.active : ""
                }`}
              />
            </div>

            <div className={styles.actions_toolbar}>
              <div onClick={() => onClose()} className={styles.cancel_button}>
                {content.newTrusteeText20}
              </div>
              <div
                onClick={(e) => handleSave(e)}
                className={styles.save_button}
              >
                {content.newTrusteeText21}
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default NewTrustee;
